module.exports = __webpack_public_path__ + "img/gatorz-policy.0bc3e69b.png";